// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `bootstrap`

import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
